<template>
   <table class="table table-striped account__table account__table--bets"
       >
      <thead class="thead-dark">
         <tr>
            <th scope="col" >{{ t('user.page.table.sportbets.ticket_id') }}</th>
            <th scope="col">{{ t('user.page.table.sportbets.created') }}</th>
            <th scope="col">{{ t('user.page.table.sportbets.sport_name') }}</th>
            <th scope="col">{{ t('user.page.table.sportbets.bet_name') }}</th>
            <th scope="col">{{ t('user.page.table.sportbets.amount') }}</th>
         </tr>
      </thead>

      <!-- Define table columns output -->
      <!--SIMPLE-->
      <tbody

      >
         <tr

             v-for="ticket in tickets"
             :key="'sportsimpel--'+snakeCase(ticket.ticket_id)"
             class="pointer"
             @click="$emit('openBet', ticket.ticket_id)"
         >
<!--:key="'bet-'+bet.id"
             v-for="bet in ticket.bets"            -->
            <th scope="row">
               <span class="pointer btn btn-link btn-sm btn-open-details" @click="$emit('openBet', ticket.ticket_id)">
                  {{ticket.ticket_id}}
               </span>
            </th>
            <td v-html="betDateString(ticket.created)"></td>
            <td>
               {{ticket.product}}
            </td>
            <td>
               {{ ticket.ticket_type }}
            </td>
            <td>
               {{formatToMoney(safeNumber(ticket.stake_amount))}}
            </td>
         </tr>
      </tbody>
      <!--COMPLEX-->

   </table>

</template>

<script>
export default {
   name: "SportSimpleTable",
   props:{
      tickets: Array
   },
   methods:{
      betDateString(date){
         date = moment(date);

         let format = 'DD/MM';
         let br = '<br>';

         return `${date.format(format)}
				${br}
				${this.formatToTime(date)}`;
      },
   }
}
</script>

<style scoped>

</style>
